import CloseIcon from "@mui/icons-material/Close";
import DragHandleIcon from "@mui/icons-material/DragHandle";
import Rotate90DegreesCwIcon from "@mui/icons-material/Rotate90DegreesCw";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Icon,
  IconButton,
  Tooltip,
} from "@mui/material";
import { Card } from "antd";
import CommentsImg_Azure from "assets/images/comments-Azure.svg";
import CommentsImg_Bisque from "assets/images/comments-Bisque.svg";
import CommentsImg_Black from "assets/images/comments-Black.svg";
import CommentsImg_Cyan from "assets/images/comments-Cyan.svg";
import CommentsImg_MediumSpringGreen from "assets/images/comments-MediumSpringGreen.svg";
import CommentsImg_Tomato from "assets/images/comments-Tomato.svg";
import CommentsImg_Violet from "assets/images/comments-Violet.svg";
import SuiBox from "components/SuiBox";
import SuiButton from "components/SuiButton";
import SuiInput from "components/SuiInput";
import SuiTypography from "components/SuiTypography";
import Prompt from "components/UpStyled/Prompt";
import CounterContext from "context/counter";
import { nanoid } from "nanoid";
import Comments from "pages/comment";
import {
  forwardRef,
  useContext,
  useEffect,
  useCallback,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import ReactDOM from "react-dom/client";
import {
  Circle,
  Image as KonvaImage,
  Label,
  Layer,
  Line,
  Shape,
  Stage,
  Text,
  Tag,
} from "react-konva";
import { Rnd } from "react-rnd";
import { useHoverDirty } from "react-use";
import api from "services/api";
import useImage from "use-image";
import toast from "react-hot-toast";
import moment from "moment";

export const describePEP = (pep, date = true) => {
  var str = "'" + pep.PEPname + "'";
  if ("width" in pep) str += " removed column " + "'" + pep.v + "'";
  else if ("index" in pep)
    str += pep.v === "" ? " added new row " + pep.index : " removed row " + pep.index;
  else {
    if (pep.v === "") str += " set new value " + "'" + pep.PEPvalue + "'";
    else if (pep.PEPvalue === "") str += " removed old value " + "'" + pep.v + "'";
    else str += " changed from " + "'" + pep.v + "'" + " to " + "'" + pep.PEPvalue + "'";
  }
  if (date) str += " at " + moment(pep.PEPdate).format("yyyy-MM-DD");
  return str;
};

export const autoCalc = (datas) => {
  delete datas.TotalCost;
  if (datas.Quantity && datas.Price) {
    var q = parseFloat(
      typeof datas.Quantity === "object" ? datas.Quantity.PEPvalue : datas.Quantity
    );
    var p = parseFloat(typeof datas.Price === "object" ? datas.Price.PEPvalue : datas.Price);
    console.log("autoCalc", datas, p, q);
    if (!isNaN(p) && !isNaN(q)) datas.TotalCost = (p * q).toFixed(2);
  }
  return datas;
};

export const SketchToolTip = forwardRef((props, ref) => {
  useImperativeHandle(ref, () => ({
    setSketchToolTip2(tooltip) {
      setSketchToolTip(tooltip);
    },
  }));
  const [sketchToolTip, setSketchToolTip] = useState("");
  var defaultMsg = "";
  if (props.method == "end")
    defaultMsg = `Use the ${props.color} arrow and other annotation tools to generate a new row in your table`;
  else if (props.method == "middle")
    defaultMsg = "You can draw a line segment using " + props.color + " on the top of image";
  else if (props.method == "dot")
    defaultMsg =
      "You can use mouse click to create a dot annotation using " +
      props.color +
      " on the top of image";
  else if (props.method == "comments")
    defaultMsg = `Use the ${props.color} comment icon above your images to leave a comment.`;
  return (
    <SuiTypography variant="body2" fontWeight="medium" sx={{ pt: 1 }}>
      {sketchToolTip != "" ? sketchToolTip : defaultMsg}
    </SuiTypography>
  );
});

export const AnnotationColors = ({ color, setColor }) => {
  const annotationColors = [
    "Black",
    "Azure",
    "Bisque",
    "Cyan",
    "MediumSpringGreen",
    "Violet",
    "Tomato",
  ];
  return (
    <SuiBox display="flex">
      {annotationColors.map((acolor) => (
        <Tooltip key={acolor} title={acolor} placement="top">
          <IconButton
            size="inherit"
            style={color == acolor ? { backgroundColor: "LightGrey" } : {}}
            onClick={() => {
              setColor(acolor);
            }}
          >
            <Icon
              baseClassName="material-icons"
              fontSize="inherit"
              style={{ color: acolor }}
              className="hover:bg-transparent"
            >
              circle
            </Icon>
          </IconButton>
        </Tooltip>
      ))}
    </SuiBox>
  );
};

export const AnnotationMethods = ({ color, method, setMethod }) => {
  //color = "Black"
  const annotationMethods = [
    { method: "end", icon: "keyboard_backspace", tooltip: "Add Arrow Line" },
    { method: "middle", icon: "open_in_full", tooltip: "Add Line Segment" },
    { method: "dot", icon: "looks_one_rounded", tooltip: "Add Point" },
  ];
  return (
    <SuiBox display="flex">
      {annotationMethods.map((amethod) => (
        <Tooltip key={amethod.method} title={amethod.tooltip} placement="top">
          <IconButton
            sx={{ mx: 0 }}
            size="inherit"
            style={method == amethod.method ? { backgroundColor: "LightGrey" } : {}}
            onClick={() => {
              if (method === amethod.method) setMethod("");
              else setMethod(amethod.method);
            }}
          >
            <Icon
              fontSize="inherit"
              style={{ color: color }}
              className="border-none hover:bg-transparent"
            >
              {amethod.icon}
            </Icon>
          </IconButton>
        </Tooltip>
      ))}
    </SuiBox>
  );
};

export const DrawSketchImage = ({ detail, sketchdata, width, height }) => {
  const [background] = useImage(sketchdata.imgurl, "anonymous", "origin");
  const rotation = sketchdata.rotation ?? 0;
  const allowDrawing = useRef(true);
  //console.log('rotation', rotation, width, height)
  const voidfunc = () => {};
  return (
    <Rnd id={"export" + sketchdata.id} size={{ width: width, height: height }}>
      <Stage className="konva" width={width} height={height}>
        <Layer>
          <KonvaImage
            image={background}
            width={rotation == 0 || rotation == 2 ? width : height}
            height={rotation == 0 || rotation == 2 ? height : width}
            rotation={rotation * 90}
            offsetX={rotation < 2 ? 0 : rotation == 2 ? width : height}
            offsetY={rotation == 0 || rotation == 3 ? 0 : rotation == 1 ? width : height}
          />
          {sketchdata.lines?.map((line) => (
            <SketchMark
              key={nanoid()}
              detail={detail}
              markdata={line}
              allowDrawing={allowDrawing}
              updateFunc={null}
              actualWidth={width}
              actualHeight={height}
              showEditFunc={null}
              editmode={0}
              sketchdata={sketchdata}
              setSketchToolTip={voidfunc}
              commentsImgs={null}
              rotation={rotation}
            />
          ))}
        </Layer>
      </Stage>
    </Rnd>
  );
};

export const getImageDataUrl = async (detail, sketchdata) => {
  const imgWidth =
    (sketchdata.rotation == 1 || sketchdata.rotation == 3
      ? sketchdata.height / sketchdata.width
      : sketchdata.width / sketchdata.height) * 500;
  const div_root = document.createElement("div");
  div_root.id = "div_root";
  const root = ReactDOM.createRoot(div_root);
  document.body.appendChild(div_root);
  var loaded = false;
  //console.log("Image start", new Date().toISOString())
  root.render(
    <div
      ref={() => {
        loaded = true;
      }}
      style={{ position: "absolute", top: "-10000px", right: "-10000px" }}
    >
      <DrawSketchImage detail={detail} sketchdata={sketchdata} width={imgWidth} height={500} />
    </div>
  );
  var loop = 0;
  while (loop < 50) {
    if (loaded) {
      await new Promise((r) => setTimeout(r, 1000));
      var sketch = document.getElementById("export" + sketchdata.id);
      //console.log('sketch', sketch)
      const uri = sketch.childNodes[0].childNodes[0].childNodes[0].toDataURL();
      root.unmount(); //React 18
      div_root.remove();
      //console.log("Image ready", new Date().toISOString())
      return uri;
    }
    await new Promise((r) => setTimeout(r, 100));
    ++loop;
  }
};

export const EditAnnot = ({
  editmode,
  annot,
  tableFields,
  annotDialogVisible,
  setAnnotDialogVisible,
  updateLine,
  deleteLine,
  detail,
  addCollaborationHistory,
}) => {
  const [color, setColor] = useState(annot?.color);
  const [method, setMethod] = useState(annot?.method);
  const [datas, setDatas] = useState(annot?.datas ?? {});
  const [deleteDialogVisible, setDeleteDialogVisible] = useState(false);
  const [currentCell, setCurrentCell] = useState({ show: false });

  useEffect(() => {
    setColor(annot?.color);
    setMethod(annot?.method);
    setDatas(annot?.datas ?? {});
  }, [annot]);

  const closeDialog = async () => {
    setAnnotDialogVisible(false);
    if (color !== annot?.color) {
      updateLine({ ...annot, color: color });
    }
  };

  return (
    <Dialog
      sx={{
        "& .MuiDialog-container": {
          "& .MuiPaper-root": {
            width: "750px",
            height: "300px",
          },
        },
      }}
      open={annotDialogVisible}
      maxWidth={"lg"}
      onClose={() => closeDialog()}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <Prompt
        heading="Delete Confirmation"
        text={`Are you sure you want to delete this annotation?`}
        visible={deleteDialogVisible}
        okText="Delete"
        okColor="dark"
        handleOk={() => {
          setAnnotDialogVisible(false);
          setDeleteDialogVisible(false);
          deleteLine(annot, editmode > 1);
        }}
        handleClose={() => setDeleteDialogVisible(false)}
      />
      <DialogTitle id="alert-dialog-title">
        {(editmode ? "Edit Annotation" : "View Annotation") + " #" + annot?.index?.toString()}
        <IconButton
          aria-label="close"
          onClick={() => closeDialog()}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        {editmode > 0 && (
          <SuiBox sx={{ mb: 1 }} display="flex" justifyContent="space-between" alignItems="center">
            <SuiTypography variant="h6">Annotation Color:</SuiTypography>
            <AnnotationColors color={color} setColor={setColor} />
          </SuiBox>
        )}
      </DialogContent>
      <DialogActions>
        {editmode > 0 && !(annot && "PEProle" in annot) && (
          <SuiButton
            onClick={() => {
              setDeleteDialogVisible(true);
            }}
            color={"dark"}
            variant="gradient"
          >
            Delete
          </SuiButton>
        )}
        <div style={{ flex: "1 0 0" }} />
      </DialogActions>
    </Dialog>
  );
};

export const EditComments = ({
  detail,
  board,
  comments,
  commentsDialogVisible,
  setCommentsDialogVisible,
  refreshComments,
}) => {
  const [color, setColor] = useState(comments?.color);
  const [deleteDialogVisible, setDeleteDialogVisible] = useState(false);
  const commentId = comments?.id;
  var isOwner = !comments?.owner_id || detail.user_id === comments?.owner_id;
  if (comments && comments.viewcommentts)
    comments.viewcommentts[detail.user_id] = comments.latestcommentts;
  const counter = useContext(CounterContext);
  const { sendCountSignal } = counter;

  useEffect(() => {
    setColor(comments?.color);
  }, [comments]);

  const closeDialog = async () => {
    setCommentsDialogVisible(false);
    if (color !== comments?.color) {
      try {
        await api.comment.sketch_update({ id: commentId, color: color });
      } catch (err) {
        console.log(err);
      }
    }
    refreshComments();
  };

  const notifyFunc = (message) => {
    var url = location.pathname + location.search;
    let pos = url.indexOf("&techpackboard=");
    if (pos > 0) url = url.substring(0, pos);
    pos = url.indexOf("&imgid=");
    if (pos > 0) url = url.substring(0, pos);
    //console.log('message', message)
    //console.log('detail', detail)
    //console.log('board', board)
    //console.log('location', location)
    // detail.project_name + (true ? "" : "(" + detail.title + " / " + board?.title + ")") +
    var desc = "Style " + detail.title;
    desc += ": " + message;
    var payload = {
      type: "Comments",
      target: url + (board ? "&techpackboard=" + board.id : "&imgid=" + comments.sketch_id),
      descr: desc,
    };
    if (detail.editmode == 2 || detail.editmode == 4) payload.user_id = detail.store_id;
    else if (detail.editmode == 3) payload.user_id = detail.provider_id;
    //console.log('payload', payload)
    if (payload.user_id && payload.user_id !== "") {
      try {
        api.notifications.create(payload).then(({ data }) => {
          sendCountSignal(payload.user_id);
          return data;
        });
      } catch (err) {
        console.log(err);
      }
    }
  };

  return (
    <Dialog
      sx={{
        "& .MuiDialog-container": {
          "& .MuiPaper-root": {
            width: "1150px",
            minHeight: "600px",
          },
        },
      }}
      open={commentsDialogVisible}
      maxWidth={"lg"}
      onClose={() => closeDialog()}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <Prompt
        heading="Delete Confirmation"
        text={`Are you sure you want to delete this comments?`}
        visible={deleteDialogVisible}
        okText="Delete"
        okColor="dark"
        handleOk={async () => {
          try {
            await api.comment.sketch_delete(commentId);
          } catch (err) {
            console.log(err);
          }
          setCommentsDialogVisible(false);
          setDeleteDialogVisible(false);
          refreshComments();
        }}
        handleClose={() => closeDialog()}
      />
      <DialogTitle id="alert-dialog-title">
        {"View Comments #" + comments?.index}
        <IconButton
          aria-label="close"
          onClick={() => closeDialog()}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ overflow: "hidden" }}>
        {isOwner && (
          <SuiBox sx={{ mb: 1 }} display="flex" justifyContent="space-between" alignItems="center">
            <SuiTypography variant="h6" sx={{ mr: 1 }}>
              Annotation Color:
            </SuiTypography>
            <AnnotationColors color={color} setColor={setColor} />
          </SuiBox>
        )}
        <Card sx={{ m: 0, p: 0 }}>
          <SuiBox sx={{ mx: 1, mt: 1.5 }}>
            <Comments subjectid={commentId} notifyFunc={notifyFunc} />
          </SuiBox>
        </Card>
      </DialogContent>
      <DialogActions>
        {isOwner && (
          <SuiButton
            onClick={() => {
              setDeleteDialogVisible(true);
            }}
            color={"dark"}
            variant="gradient"
          >
            Delete Comments
          </SuiButton>
        )}
        <div style={{ flex: "1 0 0" }} />
        {false && (
          <SuiButton
            onClick={() => {
              closeDialog();
            }}
            color={"secondary"}
            variant="gradient"
          >
            Cancel
          </SuiButton>
        )}
      </DialogActions>
    </Dialog>
  );
};

export const SketchMark = ({
  detail,
  editmode,
  markdata,
  allowDrawing,
  updateFunc,
  actualWidth,
  actualHeight,
  showEditFunc,
  sketchdata,
  setSketchToolTip,
  commentsImgs,
  rotation,
  tooltipRef = null,
}) => {
  //console.log('markdata', markdata)
  if (!markdata.endX) return <></>;
  const hoverRef1 = useRef(null);
  const isHovered1 = useHoverDirty(hoverRef1);
  const hoverRef2 = useRef(null);
  const isHovered2 = useHoverDirty(hoverRef2);
  const hoverRef3 = useRef(null);
  const isHovered3 = useHoverDirty(hoverRef3);
  const hoverRef4 = useRef(null);
  const isHovered4 = useHoverDirty(hoverRef4);

  const rotateXY = (x, y) => {
    if (rotation == 1) return [1 - y, x];
    if (rotation == 2) return [1 - x, 1 - y];
    if (rotation == 3) return [y, 1 - x];
    return [x, y];
  };

  const unRotateXY = (x, y) => {
    if (rotation == 1) return [y, 1 - x];
    if (rotation == 2) return [1 - x, 1 - y];
    if (rotation == 3) return [1 - y, x];
    return [x, y];
  };

  var rMarkdata = {};
  const calcRotate = () => {
    rMarkdata = { ...markdata };
    //console.log('markdata', markdata, "markdata.startX", markdata.startX)
    if ("startX" in markdata) {
      const [x, y] = rotateXY(markdata.startX, markdata.startY);
      rMarkdata.startX = x;
      rMarkdata.startY = y;
    }
    if ("endX" in markdata) {
      const [x, y] = rotateXY(markdata.endX, markdata.endY);
      rMarkdata.endX = x;
      rMarkdata.endY = y;
    }
    if ("middleX" in markdata) {
      const [x, y] = rotateXY(markdata.middleX, markdata.middleY);
      rMarkdata.middleX = x;
      rMarkdata.middleY = y;
    }
  };
  calcRotate();

  const [startX, setStartX] = useState(rMarkdata.startX * actualWidth);
  const [startY, setStartY] = useState(rMarkdata.startY * actualHeight);
  const [oldStartX, setOldStartX] = useState(rMarkdata.startX * actualWidth);
  const [oldStartY, setOldStartY] = useState(rMarkdata.startY * actualHeight);
  const [middleX, setMiddleX] = useState(
    rMarkdata.middleX !== null && rMarkdata.middleX !== undefined
      ? rMarkdata.middleX * actualWidth
      : null
  );
  const [middleY, setMiddleY] = useState(
    rMarkdata.middleY !== null && rMarkdata.middleY !== undefined
      ? rMarkdata.middleY * actualHeight
      : null
  );
  const [endX, setEndX] = useState(rMarkdata.endX * actualWidth);
  const [endY, setEndY] = useState(rMarkdata.endY * actualHeight);
  const [oldEndX, setOldEndX] = useState(rMarkdata.endX * actualWidth);
  const [oldEndY, setOldEndY] = useState(rMarkdata.endY * actualHeight);
  const [color, setColor] = useState(rMarkdata.color);
  const [method, setMethod] = useState(rMarkdata.method);
  const [tooltipStr, setTooltipStr] = useState("");

  var indexColor = ["Black", "Violet", "Tomato"].includes(rMarkdata.color) ? "white" : "black";
  var commentsImg = null;
  if (method == "comments") {
    [commentsImg] = commentsImgs[color];
    var isOwner = !rMarkdata.owner_id || detail.user_id === rMarkdata.owner_id;
  }

  const refreshLine = (e) => {
    allowDrawing.current = true;
    e.target.getStage().container().style.cursor = "crosshair";
    var line = { ...markdata };
    {
      const [x, y] = unRotateXY(startX / actualWidth, startY / actualHeight);
      line.startX = x;
      line.startY = y;
    }
    if (middleX !== null) {
      const [x, y] = unRotateXY(middleX / actualWidth, middleY / actualHeight);
      line.middleX = x;
      line.middleY = y;
    } else {
      line.middleX = null;
      line.middleY = null;
    }
    {
      const [x, y] = unRotateXY(endX / actualWidth, endY / actualHeight);
      line.endX = x;
      line.endY = y;
    }
    updateFunc(line);
  };

  useEffect(() => {
    calcRotate();
    setStartX(rMarkdata.startX * actualWidth);
    setStartY(rMarkdata.startY * actualHeight);
    setOldStartX(rMarkdata.startX * actualWidth);
    setOldStartY(rMarkdata.startY * actualHeight);
    setMiddleX(
      rMarkdata.middleX !== null && rMarkdata.middleX !== undefined
        ? rMarkdata.middleX * actualWidth
        : null
    );
    setMiddleY(
      rMarkdata.middleY !== null && rMarkdata.middleY !== undefined
        ? rMarkdata.middleY * actualHeight
        : null
    );
    setEndX(rMarkdata.endX * actualWidth);
    setEndY(rMarkdata.endY * actualHeight);
    setOldEndX(rMarkdata.endX * actualWidth);
    setOldEndY(rMarkdata.endY * actualHeight);
    setColor(rMarkdata.color);
    setMethod(rMarkdata.method);
  }, [markdata]);

  useEffect(() => {
    if (isHovered1 || isHovered2 || isHovered3 || isHovered4) {
      allowDrawing.current = false;
      if (isHovered1 || isHovered2)
        hoverRef1.current.getStage().container().style.cursor = "pointer";
      else if ((editmode && method !== "comments") || (method === "comments" && isOwner))
        hoverRef1.current.getStage().container().style.cursor = "move";
      var tooltip = "";
      if (isHovered1 || isHovered2) tooltip += "Click to view detail. ";
      if (editmode && method === "middle" && middleX !== null && (isHovered3 || isHovered4))
        tooltip += "Drag to move (With shift key to make it straight).";
      else if ((editmode && method !== "comments") || (method === "comments" && isOwner))
        tooltip += "Drag to move.";
      if (tooltip !== "") {
        setSketchToolTip(tooltip);
        setTooltipStr(tooltip);
      }
    } else {
      allowDrawing.current = true;
      hoverRef1.current.getStage().container().style.cursor = "crosshair";
      setSketchToolTip("");
      setTooltipStr("");
      onMouseOut();
    }
  }, [isHovered1, isHovered2, isHovered3, isHovered4]);

  var checkRange = 0;
  const checkX = (x) => {
    if (x < checkRange) x = checkRange;
    if (x > actualWidth - checkRange) x = actualWidth - checkRange;
    return x;
  };

  const checkY = (y) => {
    if (y < checkRange) y = checkRange;
    if (y > actualHeight - checkRange) y = actualHeight - checkRange;
    return y;
  };

  const onMouseMove = (e) => {
    console.log("onMouseMove", e);
    if (tooltipRef.current && tooltipStr !== "") {
      //console.log('tooltipStr', tooltipStr, 'tooltipRef.current', tooltipRef.current)
      var mousePos = e.target.getStage().getPointerPosition();
      tooltipRef.current.position({
        x: mousePos.x < 160 ? mousePos.x + 2 : mousePos.x - 160,
        y: mousePos.y - 6,
      });
      tooltipRef.current.getText().text(tooltipStr);
      tooltipRef.current.show();
    }
  };

  const onMouseOut = () => {
    if (tooltipRef?.current) tooltipRef.current.hide();
  };

  var midX = (startX + endX) / 2;
  var midY = (startY + endY) / 2;
  var PI2 = Math.PI * 2;
  var circleRadius = 10;
  var arrowLength = 14;
  var arrowWidth = 10;
  //console.log('rMarkdata.middleX', rMarkdata.middleX, 'middleX', middleX, 'middleY', middleY, 'markdata', markdata, 'rMarkdata', rMarkdata)
  return (
    <>
      {method == "comments" && (
        <>
          {!isNaN(startX) && (
            <>
              <Line
                key={rMarkdata.id}
                points={[startX, startY, endX, endY]}
                stroke={color}
                strokeWidth={2}
                tension={0}
                lineCap="butt"
              />
              <Shape
                sceneFunc={(context, shape) => {
                  var dx = endX - startX;
                  var dy = endY - startY;
                  var radians = (Math.atan2(dy, dx) + PI2) % PI2;
                  //console.log('sceneFunc', startX, startY)
                  context.beginPath();
                  context.translate(oldStartX, oldStartY);
                  context.rotate(radians);
                  context.moveTo(0, 0);
                  context.lineTo(arrowLength, arrowWidth / 2);
                  context.lineTo(arrowLength, -arrowWidth / 2);
                  context.closePath();
                  context.fillStrokeShape(shape);
                }}
                fill={color}
                stroke={color}
                strokeWidth={2}
                ref={hoverRef3}
                draggable={isOwner}
                dragBoundFunc={(p) => {
                  return {
                    x: Math.min(Math.max(p.x, -oldStartX), actualWidth - oldStartX),
                    y: Math.min(Math.max(p.y, -oldStartY), actualHeight - oldStartY),
                  };
                }}
                onDragMove={(e) => {
                  setStartX(checkX(oldStartX + e.target.x()));
                  setStartY(checkY(oldStartY + e.target.y()));
                  onMouseOut();
                }}
                onMouseMove={onMouseMove}
                onMouseOut={onMouseOut}
                onDragEnd={(e) => {
                  const [x, y] = unRotateXY(
                    checkX(oldStartX + e.target.x()) / actualWidth,
                    checkY(oldStartY + e.target.y()) / actualHeight
                  );
                  try {
                    api.comment
                      .sketch_update({ id: rMarkdata.id, startX: x, startY: y })
                      .then(({ data }) => {
                        refreshLine(e);
                        return data;
                      });
                  } catch (err) {
                    console.log(err);
                  }
                }}
              />
            </>
          )}
          <KonvaImage
            image={commentsImg}
            ref={hoverRef1}
            x={endX - 12}
            y={endY - 12}
            onclick={() => showEditFunc(rMarkdata)}
            draggable={isOwner}
            dragBoundFunc={(p) => {
              return {
                x: Math.min(Math.max(p.x, 0), actualWidth - 40),
                y: Math.min(Math.max(p.y, 0), actualHeight - 24),
              };
            }}
            onDragMove={(e) => {
              setEndX(checkX(e.target.x() + 12));
              setEndY(checkY(e.target.y() + 12));
              onMouseOut();
            }}
            onMouseMove={onMouseMove}
            onMouseOut={onMouseOut}
            onDragEnd={(e) => {
              const [x, y] = unRotateXY(
                checkX(e.target.x() + 12) / actualWidth,
                checkY(e.target.y() + 12) / actualHeight
              );
              try {
                api.comment
                  .sketch_update({ id: rMarkdata.id, endX: x, endY: y })
                  .then(({ data }) => {
                    refreshLine(e);
                    return data;
                  });
              } catch (err) {
                console.log(err);
              }
            }}
          />
          <Label x={endX + 18} y={endY} offsetX={4} offsetY={8}>
            <Text
              text={rMarkdata.index}
              fill={color}
              fontSize={15}
              align="center"
              verticalAlign="middle"
            />
          </Label>
          {markdata.newcomments && <Circle x={endX + 12} y={endY - 12} radius={4} fill="Red" />}
        </>
      )}
      {method == "dot" && (
        <>
          <Circle
            ref={hoverRef1}
            x={endX}
            y={endY}
            radius={circleRadius}
            fill={color}
            onclick={() => showEditFunc(rMarkdata)}
            draggable={editmode}
            dragBoundFunc={(p) => {
              return {
                x: Math.min(Math.max(p.x, circleRadius), actualWidth - circleRadius),
                y: Math.min(Math.max(p.y, circleRadius), actualHeight - circleRadius),
              };
            }}
            onDragMove={(e) => {
              setEndX(checkX(e.target.x()));
              setEndY(checkY(e.target.y()));
              onMouseOut();
            }}
            onMouseMove={onMouseMove}
            onMouseOut={onMouseOut}
            onDragEnd={refreshLine}
          />
          <Label
            ref={hoverRef2}
            x={endX}
            y={endY}
            offsetX={rMarkdata.index >= 10 ? 9 : 4}
            offsetY={6}
            onclick={() => showEditFunc(rMarkdata)}
            draggable={editmode}
            dragBoundFunc={(p) => {
              return {
                x: Math.min(Math.max(p.x, circleRadius), actualWidth - circleRadius),
                y: Math.min(Math.max(p.y, circleRadius), actualHeight - circleRadius),
              };
            }}
            onDragMove={(e) => {
              setEndX(checkX(e.target.x()));
              setEndY(checkY(e.target.y()));
              onMouseOut();
            }}
            onMouseMove={onMouseMove}
            onMouseOut={onMouseOut}
            onDragEnd={refreshLine}
          >
            <Text
              text={rMarkdata.index.toString()}
              fill={indexColor}
              fontSize={15}
              align="center"
              verticalAlign="middle"
            />
          </Label>
        </>
      )}
      {method == "end" && (
        <>
          <Line
            key={rMarkdata.id}
            points={[startX, startY, endX, endY]}
            stroke={color}
            strokeWidth={2}
            tension={0}
            lineCap="butt"
          />
          <Shape
            sceneFunc={(context, shape) => {
              var dx = endX - startX;
              var dy = endY - startY;
              var radians = (Math.atan2(dy, dx) + PI2) % PI2;
              //console.log('sceneFunc', startX, startY)
              context.beginPath();
              context.translate(oldStartX, oldStartY);
              context.rotate(radians);
              context.moveTo(0, 0);
              context.lineTo(arrowLength, arrowWidth / 2);
              context.lineTo(arrowLength, -arrowWidth / 2);
              context.closePath();
              context.fillStrokeShape(shape);
            }}
            fill={color}
            stroke={color}
            strokeWidth={2}
            ref={hoverRef3}
            draggable={editmode}
            dragBoundFunc={(p) => {
              return {
                x: Math.min(Math.max(p.x, -oldStartX), actualWidth - oldStartX),
                y: Math.min(Math.max(p.y, -oldStartY), actualHeight - oldStartY),
              };
            }}
            onDragMove={(e) => {
              setStartX(checkX(oldStartX + e.target.x()));
              setStartY(checkY(oldStartY + e.target.y()));
              onMouseOut();
            }}
            onMouseMove={onMouseMove}
            onMouseOut={onMouseOut}
            onDragEnd={refreshLine}
          />
          <Circle
            ref={hoverRef1}
            x={endX}
            y={endY}
            radius={circleRadius}
            fill={color}
            onclick={() => showEditFunc(rMarkdata)}
            draggable={editmode}
            dragBoundFunc={(p) => {
              return {
                x: Math.min(Math.max(p.x, circleRadius), actualWidth - circleRadius),
                y: Math.min(Math.max(p.y, circleRadius), actualHeight - circleRadius),
              };
            }}
            onDragMove={(e) => {
              setEndX(checkX(e.target.x()));
              setEndY(checkY(e.target.y()));
              onMouseOut();
            }}
            onMouseMove={onMouseMove}
            onMouseOut={onMouseOut}
            onDragEnd={refreshLine}
          />
          <Label
            ref={hoverRef2}
            x={endX}
            y={endY}
            offsetX={rMarkdata.index >= 10 ? 9 : 4}
            offsetY={6}
            onclick={() => showEditFunc(rMarkdata)}
            draggable={editmode}
            dragBoundFunc={(p) => {
              return {
                x: Math.min(Math.max(p.x, circleRadius), actualWidth - circleRadius),
                y: Math.min(Math.max(p.y, circleRadius), actualHeight - circleRadius),
              };
            }}
            onDragMove={(e) => {
              setEndX(checkX(e.target.x()));
              setEndY(checkY(e.target.y()));
              onMouseOut();
            }}
            onMouseMove={onMouseMove}
            onMouseOut={onMouseOut}
            onDragEnd={refreshLine}
          >
            <Text
              text={rMarkdata.index.toString()}
              fill={indexColor}
              fontSize={15}
              align="center"
              verticalAlign="middle"
            />
          </Label>
        </>
      )}
      {method == "middle" && (
        <>
          <Shape
            sceneFunc={(context, shape) => {
              context.beginPath();
              context.moveTo(startX, startY);
              context.quadraticCurveTo(
                midX + (middleX !== null ? (middleX - midX) * 2 : 0),
                midY + (middleY !== null ? (middleY - midY) * 2 : 0),
                endX,
                endY
              );
              context.fillStrokeShape(shape);
            }}
            stroke={color}
            strokeWidth={2}
          />
          <Shape
            sceneFunc={(context, shape) => {
              var dx = midX + (middleX !== null ? (middleX - midX) * 2 : 0) - startX;
              var dy = midY + (middleY !== null ? (middleY - midY) * 2 : 0) - startY;
              var radians = (Math.atan2(dy, dx) + PI2) % PI2;
              //console.log('sceneFunc', startX, startY)
              context.beginPath();
              context.translate(oldStartX, oldStartY);
              context.rotate(radians);
              context.moveTo(0, 0);
              context.lineTo(arrowLength, arrowWidth / 2);
              context.lineTo(arrowLength, -arrowWidth / 2);
              context.closePath();
              context.fillStrokeShape(shape);
            }}
            fill={color}
            stroke={color}
            strokeWidth={2}
            ref={hoverRef3}
            draggable={editmode}
            dragBoundFunc={(p) => {
              return {
                x: Math.min(Math.max(p.x, -oldStartX), actualWidth - oldStartX),
                y: Math.min(Math.max(p.y, -oldStartY), actualHeight - oldStartY),
              };
            }}
            onDragMove={(e) => {
              if (e.evt.shiftKey) {
                setMiddleX(null);
                setMiddleY(null);
              }
              setStartX(checkX(oldStartX + e.target.x()));
              setStartY(checkY(oldStartY + e.target.y()));
              onMouseOut();
            }}
            onMouseMove={onMouseMove}
            onMouseOut={onMouseOut}
            onDragEnd={refreshLine}
          />
          <Shape
            sceneFunc={(context, shape) => {
              var dx = midX + (middleX !== null ? (middleX - midX) * 2 : 0) - endX;
              var dy = midY + (middleY !== null ? (middleY - midY) * 2 : 0) - endY;
              var radians = (Math.atan2(dy, dx) + PI2) % PI2;
              context.beginPath();
              context.translate(oldEndX, oldEndY);
              context.rotate(radians);
              context.moveTo(0, 0);
              context.lineTo(arrowLength, arrowWidth / 2);
              context.lineTo(arrowLength, -arrowWidth / 2);
              context.closePath();
              context.fillStrokeShape(shape);
            }}
            fill={color}
            stroke={color}
            strokeWidth={2}
            ref={hoverRef4}
            draggable={editmode}
            dragBoundFunc={(p) => {
              return {
                x: Math.min(Math.max(p.x, -oldEndX), actualWidth - oldEndX),
                y: Math.min(Math.max(p.y, -oldEndY), actualHeight - oldEndY),
              };
            }}
            onDragMove={(e) => {
              if (e.evt.shiftKey) {
                setMiddleX(null);
                setMiddleY(null);
              }
              setEndX(checkX(oldEndX + e.target.x()));
              setEndY(checkY(oldEndY + e.target.y()));
              onMouseOut();
            }}
            onMouseMove={onMouseMove}
            onMouseOut={onMouseOut}
            onDragEnd={refreshLine}
          />
          <Circle
            ref={hoverRef1}
            x={middleX ?? midX}
            y={middleY ?? midY}
            radius={circleRadius}
            fill={color}
            onclick={() => showEditFunc(rMarkdata)}
            draggable={editmode}
            dragBoundFunc={(p) => {
              return {
                x: Math.min(Math.max(p.x, circleRadius), actualWidth - circleRadius),
                y: Math.min(Math.max(p.y, circleRadius), actualHeight - circleRadius),
              };
            }}
            onDragMove={(e) => {
              setMiddleX(checkX(e.target.x()));
              setMiddleY(checkY(e.target.y()));
              onMouseOut();
            }}
            onMouseMove={onMouseMove}
            onMouseOut={onMouseOut}
            onDragEnd={refreshLine}
          />
          <Label
            ref={hoverRef2}
            x={middleX ?? midX}
            y={middleY ?? midY}
            offsetX={rMarkdata.index >= 10 ? 9 : 4}
            offsetY={6}
            onclick={() => showEditFunc(rMarkdata)}
            draggable={editmode}
            dragBoundFunc={(p) => {
              return {
                x: Math.min(Math.max(p.x, circleRadius), actualWidth - circleRadius),
                y: Math.min(Math.max(p.y, circleRadius), actualHeight - circleRadius),
              };
            }}
            onDragMove={(e) => {
              setMiddleX(checkX(e.target.x()));
              setMiddleY(checkY(e.target.y()));
              onMouseOut();
            }}
            onMouseMove={onMouseMove}
            onMouseOut={onMouseOut}
            onDragEnd={refreshLine}
          >
            <Text
              text={rMarkdata.index.toString()}
              fill={indexColor}
              fontSize={15}
              align="center"
              verticalAlign="middle"
            />
          </Label>
        </>
      )}
    </>
  );
};

const SketchImage = ({
  detail,
  board,
  editmode,
  sketchdata,
  sketchcomments,
  sketchWidth,
  sketchHeight,
  color,
  method,
  updateLines,
  refreshComments,
  updateImageRatio,
  tableFields,
  stageRef,
  showComments,
  setSketchToolTip,
  rotation,
  getNextIndex,
  addCollaborationHistory,
}) => {
  const [background] = useImage(sketchdata.imgurl, "anonymous", "origin");
  const [lines, setLines] = useState([...(sketchdata.lines ?? [])]);
  const [comments, setComments] = useState(sketchcomments ?? []);
  const [imgRatio, setImgRatio] = useState(sketchdata?.imgRatio ?? 1);
  const [annotDialogVisible, setAnnotDialogVisible] = useState(false);
  const [commentsDialogVisible, setCommentsDialogVisible] = useState(false);
  const [currentAnnot, setCurrentAnnot] = useState(null);
  const allowDrawing = useRef(true);
  const isDrawing = useRef(false);
  const tooltipRef = useRef(null);

  var actualWidth = sketchWidth * imgRatio;
  var actualHeight = sketchHeight * imgRatio;

  var commentsImgs = {
    Azure: useImage(CommentsImg_Azure),
    Bisque: useImage(CommentsImg_Bisque),
    Black: useImage(CommentsImg_Black),
    Cyan: useImage(CommentsImg_Cyan),
    MediumSpringGreen: useImage(CommentsImg_MediumSpringGreen),
    Violet: useImage(CommentsImg_Violet),
    Tomato: useImage(CommentsImg_Tomato),
  };

  useEffect(() => {
    //console.log('sketchdata', sketchdata)
    setLines([...(sketchdata.lines ?? [])]);
    setImgRatio(sketchdata.imgRatio ?? 1);
  }, [sketchdata]);

  useEffect(() => {
    //console.log('sketchcomments', sketchcomments)
    setComments(sketchcomments ?? []);
  }, [sketchcomments]);

  const unRotateXY = (x, y) => {
    if (rotation == 1) return [y, 1 - x];
    if (rotation == 2) return [1 - x, 1 - y];
    if (rotation == 3) return [1 - y, x];
    return [x, y];
  };

  const handleMouseDown = (e) => {
    if (allowDrawing.current && method !== "") {
      isDrawing.current = true;
      const pos = e.target.getStage().getPointerPosition();
      const [x, y] = unRotateXY(pos.x / actualWidth, pos.y / actualHeight);
      var obj = {
        id: nanoid(),
        index: getNextIndex(),
        startX: x,
        startY: y,
        color: color,
        method: method,
        datas: {},
      };
      if (method != "comments") {
        if (editmode > 1)
          obj = {
            ...obj,
            PEProle: detail.user_id,
            PEPname: detail.user_name,
            PEPdate: new Date(),
            v: "",
            PEPvalue: obj.index,
          };
        setLines([...lines, obj]);
      } else setComments([...comments, obj]);
    }
  };

  const handleMouseMove = (e) => {
    if (isDrawing.current) {
      const stage = e.target.getStage();
      const point = stage.getPointerPosition();
      const [x, y] = unRotateXY(point.x / actualWidth, point.y / actualHeight);
      if (method != "comments") {
        let lastLine = lines[lines.length - 1];
        if (lastLine) {
          lastLine.endX = x;
          lastLine.endY = y;
          lines.splice(lines.length - 1, 1, lastLine);
          setLines([...lines]);
        }
      } else {
        let lastComment = comments[comments.length - 1];
        if (lastComment) {
          lastComment.endX = x;
          lastComment.endY = y;
          comments.splice(comments.length - 1, 1, lastComment);
          setComments([...comments]);
        }
      }
      stage.container().style.cursor = "move";
    }
  };

  const handleMouseUp = async (e) => {
    if (isDrawing.current) {
      const stage = e.target.getStage();
      const point = stage.getPointerPosition();
      const [x, y] = unRotateXY(point.x / actualWidth, point.y / actualHeight);
      if (method != "comments") {
        let lastLine = lines[lines.length - 1];
        if (
          lastLine.method != "dot" &&
          Math.abs(x - lastLine.startX) * actualWidth < 15 &&
          Math.abs(y - lastLine.startY) * actualHeight < 15
        ) {
          // not a valid line. too short
          lines.splice(lines.length - 1, 1);
        } else {
          lastLine.endX = x;
          lastLine.endY = y;
        }
        setLines([...lines]);
        updateLines(sketchdata.id, [...lines]);
      } else {
        let lastComment = comments[comments.length - 1];
        lastComment.endX = x;
        lastComment.endY = y;
        var noStart =
          Math.abs(x - lastComment.startX) * actualWidth < 15 &&
          Math.abs(y - lastComment.startY) * actualHeight < 15;
        try {
          const { data } = await api.comment.sketch_create({
            sketch_id: sketchdata.id,
            product_id: detail.id,
            metadata: {
              startX: noStart ? NaN : lastComment.startX,
              startY: noStart ? NaN : lastComment.startY,
              endX: lastComment.endX,
              endY: lastComment.endY,
              color: color,
              index: lastComment.index,
            },
          });
          lastComment.id = data.id;
          lastComment.viewcommentts = {};
        } catch (err) {
          console.log(err);
        }
        setComments([...comments]);
        refreshComments();
        setCurrentAnnot(lastComment);
        setCommentsDialogVisible(true);
      }
      stage.container().style.cursor = "crosshair";
      isDrawing.current = false;
    }
  };

  const updateLine = (line) => {
    const nextLines = lines.map((l) => {
      if (l.id === line.id) {
        return line;
      } else {
        return l;
      }
    });
    setLines(nextLines);
    updateLines(sketchdata.id, [...nextLines]);
  };

  const updateComment = (comment) => {
    const nextComments = comments.map((c) => {
      if (c.id === comment.id) {
        return comment;
      } else {
        return c;
      }
    });
    setComments(nextComments);
    refreshComments();
  };

  const deleteLine = (line, collaborationDelete = false) => {
    const nextLines = collaborationDelete
      ? lines.map((l) => {
          if (l.id === line.id) {
            if ("PEProle" in line) return l;
            return {
              ...line,
              PEProle: detail.user_id,
              PEPname: detail.user_name,
              PEPdate: new Date(),
              v: line.Code,
              PEPvalue: "",
            };
          } else {
            return l;
          }
        })
      : lines.filter((l) => l.id !== line.id);
    setLines(nextLines);
    updateLines(sketchdata.id, [...nextLines]);
  };

  const showEditAnnot = (annot) => {
    setCurrentAnnot(annot);
    setAnnotDialogVisible(true);
  };

  const showEditComments = (annot) => {
    setCurrentAnnot(annot);
    setCommentsDialogVisible(true);
  };

  /*
  var index = 1
  for (var l of lines) l.index = index++
  index = 0
  for (var c of comments) {
    c.key = sketchdata.charid + String.fromCharCode(65 + index++)
  }
  */

  //console.log('comments', comments)
  //console.log('imgRatio', imgRatio, 'actualWidth', actualWidth, 'actualHeight', actualHeight)

  return (
    <SuiBox onDragStart={(e) => e.preventDefault()} sx={{ cursor: "crosshair", border: 1 }}>
      <EditAnnot
        editmode={editmode}
        annot={currentAnnot}
        tableFields={tableFields}
        annotDialogVisible={annotDialogVisible}
        setAnnotDialogVisible={setAnnotDialogVisible}
        updateLine={updateLine}
        deleteLine={deleteLine}
        detail={detail}
        addCollaborationHistory={addCollaborationHistory}
      />
      <EditComments
        comments={currentAnnot}
        commentsDialogVisible={commentsDialogVisible}
        setCommentsDialogVisible={setCommentsDialogVisible}
        refreshComments={refreshComments}
        detail={detail}
        board={board}
      />
      <div style={{ position: "relative", width: actualWidth, height: actualHeight }}>
        <Rnd
          id={sketchdata.id}
          size={{ width: actualWidth, height: actualHeight }}
          enableResizing={{
            top: false,
            right: updateImageRatio !== null,
            bottom: updateImageRatio !== null,
            left: false,
            topRight: false,
            bottomRight: updateImageRatio !== null,
            bottomLeft: false,
            topLeft: false,
          }}
          onResize={(e, direction, ref, delta, position) => {
            setImgRatio(ref.offsetHeight / sketchHeight);
            updateImageRatio(sketchdata.id, ref.offsetHeight / sketchHeight, false);
          }}
          onResizeStop={(e, direction, ref, delta, position) => {
            setImgRatio(ref.offsetHeight / sketchHeight);
            updateImageRatio(sketchdata.id, ref.offsetHeight / sketchHeight, true);
          }}
          maxHeight={sketchHeight}
          minHeight={100}
          disableDragging
          lockAspectRatio
        >
          <Stage
            className="konva"
            ref={stageRef}
            width={actualWidth}
            height={actualHeight}
            onTouchStart={handleMouseDown}
            onTouchMove={handleMouseMove}
            onTouchEnd={handleMouseUp}
            onMouseDown={handleMouseDown}
            onMousemove={handleMouseMove}
            onMouseup={handleMouseUp}
          >
            <Layer>
              <KonvaImage
                image={background}
                width={rotation == 0 || rotation == 2 ? actualWidth : actualHeight}
                height={rotation == 0 || rotation == 2 ? actualHeight : actualWidth}
                rotation={rotation * 90}
                offsetX={rotation < 2 ? 0 : rotation == 2 ? actualWidth : actualHeight}
                offsetY={
                  rotation == 0 || rotation == 3 ? 0 : rotation == 1 ? actualWidth : actualHeight
                }
                id="backgroundImage"
              />
              {lines.map((line, i) => (
                <SketchMark
                  key={nanoid()}
                  detail={detail}
                  markdata={line}
                  allowDrawing={allowDrawing}
                  updateFunc={updateLine}
                  actualWidth={actualWidth}
                  actualHeight={actualHeight}
                  showEditFunc={showEditAnnot}
                  editmode={editmode}
                  sketchdata={sketchdata}
                  setSketchToolTip={setSketchToolTip}
                  commentsImgs={commentsImgs}
                  rotation={rotation}
                  tooltipRef={tooltipRef}
                />
              ))}
              {showComments &&
                comments.map((line, i) => (
                  <SketchMark
                    key={nanoid()}
                    detail={detail}
                    markdata={line}
                    allowDrawing={allowDrawing}
                    updateFunc={updateComment}
                    actualWidth={actualWidth}
                    actualHeight={actualHeight}
                    showEditFunc={showEditComments}
                    editmode={editmode}
                    sketchdata={sketchdata}
                    setSketchToolTip={setSketchToolTip}
                    commentsImgs={commentsImgs}
                    rotation={rotation}
                    tooltipRef={tooltipRef}
                  />
                ))}
            </Layer>
            <Layer>
              <Label ref={tooltipRef} opacity={0.75} x={-10000} y={-10000}>
                <Tag fill="#FFFFFF" />
                <Text
                  fontSize={14}
                  align="center"
                  verticalAlign="middle"
                  width={140}
                  fill="black"
                />
              </Label>
            </Layer>
          </Stage>
        </Rnd>
      </div>
    </SuiBox>
  );
};

const Sketch = ({
  detail,
  board,
  editmode,
  sketchdata,
  sketchcomments,
  sketchHeight,
  color,
  method,
  updateLines,
  refreshComments,
  updateImageRatio,
  updateRotation,
  tableFields,
  setIsDragDisabled,
  imageFilter,
  setImageFilter,
  setDeleteImage,
  setDeleteImgDialogVisible,
  sketchDatas,
  showComments,
  setSketchToolTip,
  getNextIndex,
  addCollaborationHistory,
}) => {
  const [rotation, setRotation] = useState(sketchdata.rotation ?? 0);
  const stageRef = useRef(null);

  useEffect(() => {
    setRotation(sketchdata.rotation ?? 0);
  }, [sketchdata]);

  const handleExport = () => {
    const uri = stageRef.current.toDataURL();
    //console.log('uri', uri)
    var link = document.createElement("a");
    link.download = sketchdata.name;
    link.href = uri;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  var sketchWidth =
    sketchHeight *
    (rotation == 0 || rotation == 2
      ? sketchdata.width / sketchdata.height
      : sketchdata.height / sketchdata.width);
  var actualWidth = sketchWidth * (sketchdata.imgRatio ?? 1);
  var isBillMaterials = board?.id === "BillMaterials";
  return (
    <SuiBox sx={{ pr: 0 }}>
      <SuiBox
        className="flex items-center justify-between"
        sx={{ width: actualWidth }}
        onMouseEnter={() => {
          if (setIsDragDisabled) setIsDragDisabled(false);
        }}
        onMouseLeave={() => {
          if (setIsDragDisabled) setIsDragDisabled(true);
        }}
      >
        <SuiBox className="flex items-center">
          {isBillMaterials && <SuiTypography>{sketchdata.name}</SuiTypography>}
          {sketchDatas?.length > 1 && editmode > 0 && !isBillMaterials && (
            <DragHandleIcon fontSize="small" />
          )}
        </SuiBox>
        <SuiBox className="flex items-center">
          {sketchDatas?.length > 1 && !isBillMaterials && (
            <SuiButton
              sx={{ mx: -0.5, my: 0, p: 0, fontSize: 12, textTransform: "none" }}
              color="dark"
              size="small"
              variant="text"
              onClick={(e) => {
                setImageFilter(imageFilter == "" ? sketchdata.id : "");
              }}
            >
              View
              <br />
              {imageFilter == "" ? "me only" : "all"}
            </SuiButton>
          )}
          {editmode > 0 && !isBillMaterials && (
            <Tooltip title="Rotate Image" placement="top">
              <IconButton
                size="small"
                sx={{ mx: -0.5 }}
                onClick={() => {
                  var nextrotation = rotation == 3 ? 0 : rotation + 1;
                  setRotation(nextrotation);
                  updateRotation(sketchdata.id, nextrotation);
                }}
              >
                <Rotate90DegreesCwIcon
                  fontSize="small"
                  className="border-none hover:bg-transparent"
                />
              </IconButton>
            </Tooltip>
          )}
          {!isBillMaterials && (
            <Tooltip title="Download image" placement="top">
              <IconButton
                size="small"
                sx={{ mx: -0.5 }}
                onClick={() => {
                  handleExport();
                }}
              >
                <Icon fontSize="small" className="border-none hover:bg-transparent">
                  download
                </Icon>
              </IconButton>
            </Tooltip>
          )}
          {editmode > 0 && (
            <Tooltip title="Remove image" placement="top">
              <IconButton
                size="small"
                sx={{ mx: -0.5 }}
                onClick={() => {
                  if (setDeleteImage) setDeleteImage(sketchdata.id);
                  setDeleteImgDialogVisible(true);
                }}
              >
                <Icon fontSize="small" className="border-none hover:bg-transparent">
                  clear
                </Icon>
              </IconButton>
            </Tooltip>
          )}
        </SuiBox>
      </SuiBox>
      <SketchImage
        detail={detail}
        board={board}
        sketchdata={sketchdata}
        sketchcomments={sketchcomments}
        sketchWidth={sketchWidth}
        sketchHeight={sketchHeight}
        color={color}
        method={method}
        updateLines={updateLines}
        refreshComments={refreshComments}
        updateImageRatio={updateImageRatio}
        tableFields={tableFields}
        stageRef={stageRef}
        showComments={showComments}
        editmode={editmode}
        setSketchToolTip={setSketchToolTip}
        rotation={rotation}
        getNextIndex={getNextIndex}
        addCollaborationHistory={addCollaborationHistory}
      />
    </SuiBox>
  );
};

export default Sketch;
